<template>
  
<div>
    <chat-window
        v-if="socketChat!=null"
        :current-user-id="currentUserId"
        :rooms="rooms"
        :messages="messages"
        :messages-loaded="messagesLoaded"
        :rooms-loaded="roomLoaded"
        :loading-rooms="loadingRooms"
        :single-room="true"

        @send-message="sendMessage"
        @fetch-messages="fetchMessages"
        @open-file="openFile"
        @send-message-reaction="sendMessageReaction"
        @edit-message="editMessage"
        @delete-message="deleteMessage"
    />
</div>
</template>

<script>
  import ChatWindow from 'vue-advanced-chat'
  import 'vue-advanced-chat/dist/vue-advanced-chat.css'
  import { parseTimestamp, isSameDay } from '@/utils/dates'
  import chatService from '@/services/chat.service.js'
  import { io } from "socket.io-client";
  import {WS_CHAT, WS_CHAT_PATH, BASE_URL} from "@/services/base-url.js"

  var crService = new chatService();
  var ws_chat_url = WS_CHAT;
  var ws_chat_path = WS_CHAT_PATH;
  var base_url = BASE_URL;
  
  export default {
    components: {
      ChatWindow
    },
    data() {
      return {
        rooms: [],
        currentRoom:null,
        roomLoaded:false,
        messages: [],
        messagesLoaded: false,
        currentUserId: "",
        loadingRooms: true,
        pageMessage:0,
        messagesPerPage:10,
        startMessages: null,
        endMessages: null,
        numberOfMessageLoad:0,
        socketChat:null,
      }     
    },
    computed:{
        socket: function() {return this.$socket}
    },
    methods:{
        loadRoom()
        {
            if(this.$route.params.roomType != "singleConv")
            {
                //TO-DO : charger le room correspondant au projet
                crService.getChatRoom(this.$auth.token(), this.$route.params.chatRoomId)
                .then(chatRoom=>{

                    let room = [{
                        roomId:chatRoom.uuid,
                        roomName: chatRoom.roomName,
                        users: [],
                        lastUpdated: chatRoom.lastUpdated,
                        avatar:"",
                        unreadCount: 0,
                        index:0,
                        typingUsers: [],
                    }]

                    chatRoom.users.forEach(user=>{
                        let newUser = {
                        _id:user,
                        username:user,
                        avatar:"",
                        }
                        room[0].users.push(newUser);
                    })

                    this.rooms = room
                    this.currentRoom = this.rooms[0];
                    this.loadingRooms = false;


                    this.connectToChatServer();
                })
            }else{
                //Sinon on tente d'ouvrir une chatroom privé avec l'utilisateur en question
                crService.checkPrivateConv(this.$auth.token(),this.$route.params.chatRoomId )
                .then(res=>{
                    
                    if(res.length === 0)
                    {
                        //On fait la room privé
                        crService.createPrivateConv(this.$auth.token(), this.$auth.getMyUser().username, this.$route.params.chatRoomId)
                        .then(chatRoom=>{

                            let roomName = ""

                            if(this.$route.params.chatRoomId === "quanteec")
                            {
                                roomName = "Direct chat with QUANTEEC support team"
                            }else {
                                roomName = this.$route.params.chatRoomId
                            }

                            let room = [{
                                roomId:chatRoom.uuid,
                                roomName: roomName,
                                users: [],
                                lastUpdated: chatRoom.lastUpdated,
                                avatar:"",
                                unreadCount: 0,
                                index:0,
                                typingUsers: [],
                            }]

                            chatRoom.users.forEach(user=>{
                                let newUser = {
                                _id:user,
                                username:user,
                                avatar:"",
                                }
                                room[0].users.push(newUser);
                            })

                            this.rooms = room
                            this.currentRoom = this.rooms[0];
                            this.loadingRooms = false;


                            this.connectToChatServer();
                        })
                    }else
                    {
                            let roomName = ""

                            if(this.$route.params.chatRoomId === "quanteec")
                            {
                                roomName = "Direct chat with QUANTEEC support team"
                            }else {
                                roomName = this.$route.params.chatRoomId
                            }

                        let chatRoom = res[0];
                        crService.getChatRoom(this.$auth.token(), chatRoom.uuid)
                        .then(chatRoom=>{

                            let room = [{
                                roomId:chatRoom.uuid,
                                roomName: roomName,
                                users: [],
                                lastUpdated: chatRoom.lastUpdated,
                                avatar:"",
                                unreadCount: 0,
                                index:0,
                                typingUsers: [],
                            }]

                            chatRoom.users.forEach(user=>{
                                let newUser = {
                                _id:user,
                                username:user,
                                avatar:"",
                                }
                                room[0].users.push(newUser);
                            })

                            this.rooms = room
                            this.currentRoom = this.rooms[0];
                            this.loadingRooms = false;


                            this.connectToChatServer();
                        })
                    }
                }).catch(error => {
                    if(error.response.status === 404)
                    {
                        this.newConvState = false;
                        this.invalidFeedbackConv = error.response.data
                    }
                })                


            }       
        },

        fetchMessages() {
            this.messagesLoaded = false


            if(this.currentRoom)
            {
                this.pageMessage++;
                crService.getMessages(this.$auth.token(), this.pageMessage, this.messagesPerPage, this.currentRoom.roomId)
                .then(messages=>{
                        
                    
                    console.log(messages)
                    messages.forEach(message=>{
                        const formattedMessage = this.formatMessage(this.currentRoom.roomId, message)
                        
                        //On vérifie que le message n'est pas déjà affiché
                        const messageIndex = this.messages.findIndex(m => m._id === message._id)
                        if (messageIndex === -1) {
                            //this.messages = this.messages.concat([formattedMessage])
                            this.messages.unshift(formattedMessage)
                        } else {
                            this.$set(this.messages, messageIndex, formattedMessage)
                        }
                    })
                    
                    if(messages.length === 0)
                        this.messagesLoaded = true;
                })
            }''

        },

        async sendMessage({ content, roomId, files, replyMessage })
        {
            const message = {
                sender_id: this.currentUserId,
                content,
                timestamp: new Date()
            }

            if(files)
            {                
                message.files = [
                {
                    name: files[0].name,
                    size: files[0].size,
                    type: files[0].type,
                    extention: files[0].extention || files[0].type,
                    url: files[0].localUrl
                }]

                if(files[0].audio)
                {
                    message.files[0].audio = true
                    message.files[0].duration = files[0].duration
                }
            }
            

                if(replyMessage)
                {
                    message.replyMessage = {
                        _id: replyMessage._id,
                        content: replyMessage.content,
                        sender_id: replyMessage.senderId,
                    }
                    if(replyMessage.files)
                    {
                        message.replyMessage.files= replyMessage.files
                    }
                }
                                
                var roomMessage = this.rooms[0]
                

                //TO-DO ==> On enregistre le message en BDD avec le service
                //On envoie un socket puis
                crService.newMessage(this.$auth.token(),message,roomMessage.roomId)
                .then(newMessage => {
                    this.newMessage(newMessage, roomMessage)
                    this.socketChat.emit("sendMessage", newMessage, this.currentRoom.roomId)
                    if (files) {
                        this.uploadFile({ file:files[0], messageId: newMessage.uuid, roomId})
                    }
                }).catch(err =>{
                    console.log(err)
                })
                
                
                
                //Fonction pour stocker le message en BDD
                //On va plutôt utiliser un serveur de websocket pour envoyer le message
                //Pour ça on va utiliser le serveur de projet Vireed
                //const {id} = await messageRef(roomId).add(message)

                //Fonction d'upload du fichier
                //if (file) this.uploadFile({ file, messageId: id, roomId })
                
                //Fonction pour mettre à jour le champ "lastUpdated de la room en BDD"
                //roomsRef.doc(roomId).update({ lastUpdated: new Date() })
        },
        
		async uploadFile({ file, messageId, roomId }) {
			let type = file.extension || file.type
			if (type === 'svg' || type === 'pdf') {
				type = file.type
			}

            crService.uploadFile(this.$auth.token(), file, roomId, messageId)
            .then((message)=>{
                this.socketChat.emit("sendMessage", message, this.currentRoom.roomId)
                this.newMessage(message, roomId)
                
            })
		},

        newMessage(message, room)
        { 
            const formattedMessage = this.formatMessage(room, message)
            const messageIndex = this.messages.findIndex(m => m._id === message._id)
			if (messageIndex === -1) {
			    this.messages = this.messages.concat([formattedMessage])
			} else {
                this.$set(this.messages, messageIndex, formattedMessage)
			}
			//this.markMessagesSeen(room, message)            
        },

        //Danc cette fonction on met à jour le champs "seen du message"
        markMessagesSeen(room, message) {
            console.log("here")
			if (
				message.sender_id !== this.currentUserId &&
				(!message.seen || !message.seen[this.currentUserId])
			) {
                crService.updateSeenMessage(this.$auth.token(), message._id, this.currentRoom.roomId)
                .then(message=>{
                    this.socketChat.emit("sendMessage", message, this.currentRoom.roomId)
                    this.newMessage(message, roomId)
                })
			}
		},

		formatMessage(room, message) {

            const { sender_id, timestamp } = message
			var formatMessage = {
				...message,
				...{
					senderId: sender_id,
					_id: message._id,
					seconds: timestamp.seconds,
					timestamp: parseTimestamp(timestamp, 'HH:mm'),
					date: parseTimestamp(timestamp, 'DD MMMM YYYY'),
					username: sender_id,
					// avatar: senderUser ? senderUser.avatar : null,
					distributed: true,
				}
			}
            
            console.log(base_url)

            if(formatMessage.files)
            {
                formatMessage.files[0].url = base_url + formatMessage.files[0].path
            }

            return formatMessage;
		},

        formatTimestamp(date, timestamp) {
			const timestampFormat = isSameDay(date, new Date()) ? 'HH:mm' : 'DD/MM/YY'
			const result = parseTimestamp(timestamp, timestampFormat)
			return timestampFormat === 'HH:mm' ? `Today, ${result}` : result
		},
       
        resetMessages() {
			this.messages = []
			this.messagesLoaded = false
			this.startMessages = null
			this.endMessages = null
            this.pageMessage=1
		},

        openFile({ message }) {
			window.open(message.files[0].url, '_blank')
		},

        connectToChatServer()
        {
            if(!this.socketChat)
            {
                this.socketChat = io(ws_chat_url, { path: ws_chat_path});

                this.socketChat.on("connect", () => {
                    console.log(this)
                    console.log("Connecté au chat")
                    this.socketChat.emit("room", this.currentRoom.roomId)

                    //Une fois que l'on a rejoint une room on récupère les messages
                    this.socketChat.on("joined", ()=>{
                        this.fetchMessages();
                    })
                })

                this.socketChat.on("newMessage", (message, roomId)=>{
                    if(this.currentRoom.roomId === roomId) 
                    {
                        this.newMessage(message);  
                    }
                })                

                
            }
        },

        async sendMessageReaction({ reaction, remove, messageId, roomId }) {
            console.log(reaction)
            if(!remove)
            {
                crService.addReaction(this.$auth.token(), messageId, reaction.unicode, roomId)
                .then(newMessage=>{
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                })
            }else if (remove)
            {
                crService.removeReaction(this.$auth.token(), messageId, reaction.unicode, roomId)
                .then(newMessage=>{
                    console.log(newMessage)
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                })
            }
        },

        async editMessage({ messageId, newContent, roomId, files }) {
			const newMessage = { edited: new Date() }
			newMessage.content = newContent
			if (files) {
				newMessage.files = [{
					name: files[0].name,
					size: files[0].size,
					type: files[0].type,
					extension: files[0].extension || files[0].type,
					url: files[0].url || files[0].localUrl
				}]
				if (files[0].audio) {
					newMessage.files[0].audio = true
					newMessage.files[0].duration = files[0].duration
				}
			} else {
				newMessage.$unset = {files:true}
			}
                crService.editMessage(this.$auth.token(),newMessage,roomId, messageId)
                .then(newMessage => {
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, this.currentRoom.roomId)
                    if (files) {
                        this.uploadFile({ file:files[0], messageId: newMessage.uuid, roomId})
                    }
                }).catch(err =>{
                    console.log(err)
                })
		},

        async deleteMessage({ message, roomId }) {
            crService.deleteMessage(this.$auth.token(), message._id, roomId)
            .then(deletedMessage=>{
                this.newMessage(deletedMessage, roomId)
                this.socketChat.emit("sendMessage", deletedMessage, this.currentRoom.roomId)

            })
		},
    },
    mounted()
    {
        //Serveur de WS indépendant ==> Oui

        this.currentUserId = this.$auth.getMyUser().username,
        this.loadRoom();

        //this.updateuserOnlineStatus();
    },
  }
</script>